import { Skeleton } from '@/components/ui/skeleton'

type TableCardSkeletonProps = {
  rows?: number
}

export function TableCardSkeleton({ rows = 5 }: TableCardSkeletonProps) {
  return (
    <div className="rounded-2xl bg-white shadow-[48px_27px_74px_0px_rgba(0,0,0,0.12)] p-6">
      {/* Table header */}
      <div className="flex gap-4 mb-4 pb-3 border-b border-surface-border">
        <Skeleton className="h-4 w-1/4 rounded" />
        <Skeleton className="h-4 w-1/4 rounded" />
        <Skeleton className="h-4 w-1/6 rounded" />
        <Skeleton className="h-4 w-1/6 rounded" />
      </div>
      {/* Table rows */}
      <div className="space-y-4">
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i} className="flex gap-4 items-center">
            <Skeleton className="h-4 w-1/4 rounded" />
            <Skeleton className="h-4 w-1/4 rounded" />
            <Skeleton className="h-4 w-1/6 rounded" />
            <Skeleton className="h-4 w-1/6 rounded" />
          </div>
        ))}
      </div>
    </div>
  )
}
